import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PagePayload } from "@core/interface/core";
import { ParkingManagementConfigurationListItem, ParkingManagementConfigurationItem, ParkingManagementConfigurationResponse, AddParkingManagementConfigurationResponse } from "@core/interface/parking-managment-configuration";
import { environment } from "@environment/environment";

@Injectable({
  providedIn: 'root',
})
export class ParkingManagementConfigurationService {
  constructor(private http: HttpClient) {}

  getParkingManagementConfigurationMasterList(key: ParkingManagementConfigurationListItem, data: PagePayload) {
    switch (key) {
        case ParkingManagementConfigurationListItem.PaymentType:
            return this.gePaymentType(data);
        default:
            return this.gePaymentType(data);
        }
    }

    editParkingManagementConfiguration(key: ParkingManagementConfigurationListItem, data: ParkingManagementConfigurationItem) {
    switch (key) {
        case ParkingManagementConfigurationListItem.PaymentType:
          return this.addPaymentType(data);
        default:
          return this.addPaymentType(data);
      }
    }

  gePaymentType(data?: PagePayload) {
    const filter = { ...data };
    let httpParams = new HttpParams();
    if (filter)
    Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
        key,
        (filter[key as keyof PagePayload] as any) || ''
        );
    });
    return this.http.get<ParkingManagementConfigurationResponse>(
    environment.endPoints.parkingPaymentTypeList,
    {
        params: httpParams,
    }
    );
  }

  addPaymentType(data: ParkingManagementConfigurationItem) {
    return this.http.post<AddParkingManagementConfigurationResponse>(
        environment.endPoints.parkingPaymentTypeAddEdit,
        data
    );
  }   
}